import React from "react";
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import BarChart from "components/charts/BarChart";
import Card from "components/card/Card";

export default function WeeklyReservations({ labels = [], data = [] }) {
    const textColor  = useColorModeValue("secondaryGray.900", "white");
    const mutedColor = useColorModeValue("gray.500", "whiteAlpha.600");
    const headerBorderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
    const total      = data.reduce((a, b) => a + b, 0);

    const chartData = [{ name: "Check-in", data }];

    const chartOptions = {
        chart: { toolbar: { show: false } },
        tooltip: {
            style: { fontSize: "12px" },
            theme: "dark",
        },
        xaxis: {
            categories: labels,
            labels: {
                style: { colors: "#A3AED0", fontSize: "13px", fontWeight: "500" },
            },
            axisBorder: { show: false },
            axisTicks:  { show: false },
        },
        yaxis: {
            show: false,
        },
        grid: { show: false },
        fill: { colors: ["#4318FF"] },
        dataLabels: { enabled: false },
        plotOptions: {
            bar: { borderRadius: 6, columnWidth: "50%" },
        },
    };

    return (
        <Card align="center" direction="column" w="100%" h="100%" p="0">
            <Flex justify="space-between" align="center" pt="20px" pb="16px" px="24px" borderBottom="1px solid" borderColor={headerBorderColor} w="100%">
                <Text color="secondaryGray.900" fontSize="18px" fontWeight="700" lineHeight="100%">
                    Check-in Settimanali
                </Text>
                <Text color={mutedColor} fontSize="xs" fontWeight="500">
                    Ultimi 7 giorni
                </Text>
            </Flex>
            <Flex direction="column" align="start" w="100%" px="24px" pt="20px" pb="24px" flex="1">
                <Text color={textColor} fontSize="34px" fontWeight="700" lineHeight="100%" mb="10px">
                    {total}
                </Text>
                <Box h="200px" mt="auto" w="100%">
                    <BarChart chartData={chartData} chartOptions={chartOptions} />
                </Box>
            </Flex>
        </Card>
    );
}
